import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [activeCompanyId, setActiveCompanyId] = useState(
    () => localStorage.getItem("activeCompanyId") || null
  );

  useEffect(() => {
    if (!user) return;
    api
      .get("/companies")
      .then((r) => {
        setCompanies(r.data);
        if (user.role === "bureau_admin" || user.role === "processor") {
          const stored = localStorage.getItem("activeCompanyId");
          const valid = r.data.find((c) => c.id === stored);
          const next = valid ? stored : r.data[0]?.id || null;
          setActiveCompanyId(next);
        } else {
          setActiveCompanyId(user.company_id || null);
        }
      })
      .catch(() => {});
  }, [user]);

  const selectCompany = (id) => {
    setActiveCompanyId(id);
    localStorage.setItem("activeCompanyId", id);
  };

  const refreshCompanies = () => api.get("/companies").then((r) => setCompanies(r.data)).catch(() => {});
  const activeCompany = companies.find((c) => c.id === activeCompanyId) || null;

  return (
    <CompanyContext.Provider
      value={{ companies, setCompanies, activeCompanyId, activeCompany, selectCompany, refreshCompanies }}
    >
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
